let _ = t => t,
  _t;
import styled from 'styled-components';
import { defaultPx, asIs, toCss } from '../_internal/utils/styles';
import Box from '../Box';
export const propsMap = {
  $fontSize: {
    name: 'font-size',
    apply: defaultPx
  },
  $fontWeight: {
    name: 'font-weight',
    apply: asIs
  },
  $lineHeight: {
    name: 'line-height',
    apply: defaultPx
  },
  $fontStyle: {
    name: 'font-style',
    apply: asIs
  },
  $letterSpacing: {
    name: 'letter-spacing',
    apply: defaultPx
  }
};
export const StyledBox = styled(Box)(_t || (_t = _`
    ${0};
`), toCss(propsMap));